import DiscordIcon from '@/components/icons/logos/discord'
import FacebookIcon from '@/components/icons/logos/facebook'
import FacebookGamingIcon from '@/components/icons/logos/facebook-gaming'
import InstagramIcon from '@/components/icons/logos/instagram'
import TikTokIcon from '@/components/icons/logos/tiktok'
import TwitchIcon from '@/components/icons/logos/twitch'
import TwitterIcon from '@/components/icons/logos/twitter'
import WebIcon from '@/components/icons/logos/web'
import YoutubeIcon from '@/components/icons/logos/youtube'
import PsIcon from '@/components/icons/platforms/ps'
import XboxIcon from '@/components/icons/platforms/xbox-one'
import {
  formatProfileLinkValue,
  getProfileLinkService,
  profileLinkServices,
} from '@/resources/profile-link-services'

const serviceIcons = {
  website: WebIcon,
  psn: PsIcon,
  'xbox-live': XboxIcon,
  'discord-server': DiscordIcon,
  twitter: TwitterIcon,
  instagram: InstagramIcon,
  facebook: FacebookIcon,
  'facebook-gaming': FacebookGamingIcon,
  twitch: TwitchIcon,
  tiktok: TikTokIcon,
  youtube: YoutubeIcon,
}

export const linkServices = profileLinkServices.map((service) => ({
  ...service,
  base_url: service.baseUrl,
  url_replace: service.urlReplace,
  icon: serviceIcons[service.id],
}))

export const formatLinkServiceUrl = (serviceId, urlStr) => {
  return formatProfileLinkValue(serviceId, urlStr)
}

export const getLinkServiceBaseUrl = (serviceId) => {
  return getProfileLinkService(serviceId)?.baseUrl || ''
}
